// Environment variables - accessing them statically so Vite can replace them at build time
export const ENV_VARS = {
  // DIALOGFLOW CX Variables
  DIALOGFLOW_CX_PROJECT_ID: process.env.REACT_APP_DIALOGFLOW_CX_PROJECT_ID,
  DIALOGFLOW_CX_AGENT_ID: process.env.REACT_APP_DIALOGFLOW_CX_AGENT_ID,
  DIALOGFLOW_CX_SAP_CHANGE_OWNER_AGENT_ID: process.env.REACT_APP_DIALOGFLOW_CX_SAP_CHANGE_OWNER_AGENT_ID,
  DIALOGFLOW_CX_WALK_IN_CENTER_AGENT_ID: process.env.REACT_APP_DIALOGFLOW_CX_WALK_IN_CENTER_AGENT_ID,
  DIALOGFLOW_CX_GET_HELP_AGENT_ID: process.env.REACT_APP_DIALOGFLOW_CX_GET_HELP_AGENT_ID,
  DIALOGFLOW_CX_UNLOCK_RESET_BY_ITONE_AGENT_ID: process.env.REACT_APP_DIALOGFLOW_CX_UNLOCK_RESET_BY_ITONE_AGENT_ID,
  DIALOGFLOW_CX_PCLM_AGENT_ID: process.env.REACT_APP_DIALOGFLOW_CX_PCLM_AGENT_ID,
  DIALOGFLOW_CX_Re_Resitor_MFA: process.env.REACT_APP_DIALOGFLOW_CX_Re_Resitor_MFA,
  DIALOGFLOW_CX_AD_AGENT_ID: process.env.REACT_APP_DIALOGFLOW_CX_AD_AGENT_ID,
  DIALOGFLOW_CX_UNLOCK_RESET_SAP_AGENT_ID: process.env.REACT_APP_DIALOGFLOW_CX_UNLOCK_RESET_SAP_AGENT_ID,
  DIALOGFLOW_CX_ARIBA: process.env.REACT_APP_DIALOGFLOW_CX_ARIBA,
  
  // GENESYS LiveChat Variables
  GENESYS_LIVECHAT_ENVIRONMENT: process.env.REACT_APP_GENESYS_LIVECHAT_ENVIRONMENT,
  GENESYS_LIVECHAT_DEPLOYMENT_ID: process.env.REACT_APP_GENESYS_LIVECHAT_DEPLOYMENT_ID,
  
  // Azure Auth Variables (without REACT_APP_ prefix)
  AZ_TENANT_ID: process.env.AZ_TENANT_ID,
  AZ_CLIENT_ID: process.env.AZ_CLIENT_ID,
  SD_URL: process.env.SD_URL,
  APP_ENV: process.env.APP_ENV || process.env.REACT_APP_ENV,
  
  // API Variables
  LAMBDA_AD: process.env.REACT_APP_LAMBDA_AD,
  LAMBDA_EHR: process.env.REACT_APP_LAMBDA_EHR,
  LAMBDA_SAP: process.env.REACT_APP_LAMBDA_SAP,
  LAMBDA_SAP47: process.env.REACT_APP_LAMBDA_SAP47,
  LAMBDA_SCGP: process.env.REACT_APP_LAMBDA_SCGP,
  LAMBDA_TALK: process.env.REACT_APP_LAMBDA_TALK,
  LAMBDA_SCGARIBA: process.env.REACT_APP_LAMBDA_SCGARIBA,
  
  CSHARP_API_AD: process.env.REACT_APP_CSHARP_API_AD,
  CSHARP_API_EHR: process.env.REACT_APP_CSHARP_API_EHR,
  CSHARP_API_SAP: process.env.REACT_APP_CSHARP_API_SAP,
  CSHARP_API_S47: process.env.REACT_APP_CSHARP_API_S47,
  CSHARP_API_SCGP: process.env.REACT_APP_CSHARP_API_SCGP,
  CSHARP_API_TALK: process.env.REACT_APP_CSHARP_API_TALK,
  CSHARP_API_SCGARIBA: process.env.REACT_APP_CSHARP_API_SCGARIBA,
  
  AUTHORIZATIONTOKEN: process.env.REACT_APP_AUTHORIZATIONTOKEN,
};
